import React, { Component } from 'react';
import { Link } from 'gatsby';

import cn from 'clsx';
import * as css from './PageTabs.module.scss';
import type { Tab } from 'src/util/types';

export type Props = {
    title: string;
    tabs: Tab[];
    slug: string;
    currentTab?: string;
};

export class PageTabs extends Component<Props> {
    render() {
        const { title, tabs, slug, currentTab } = this.props;
        const $currentTab = currentTab ?? slug.split('/').filter(Boolean).slice(-1)[0];

        const pageTabs = tabs.map(tab => {
            const isSelected: boolean = tab.slug === $currentTab;

            // matches with or without
            //  - trailing slash: /?
            //  - hash link: (#.*)?
            const currentTabRegex = new RegExp(`${$currentTab}/?(#.*)?$`);
            const href = slug.replace(currentTabRegex, tab.slug);

            return (
                <li key={tab.slug} className={cn(css.listItem, isSelected && css.selectedItem)}>
                    <Link className={css.link} to={href} children={tab.title} />
                </li>
            );
        });

        return (
            <div className={css.tabsContainer}>
                <div className="cds--grid">
                    <div className="cds--row">
                        <div className="cds--col-lg-12 cds--col-no-gutter">
                            <nav aria-label={title}>
                                <ul className={css.list} children={pageTabs} />
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
